@if (items().length) {
  <div class="pt-4 pb-1 d-flex flex-wrap gap-3">
    @for (item of items(); track item) {
      <div
        class="badge badge-light-primary fw-bold d-flex align-items-center gap-2"
      >
        {{ item.name }}
        <button
          class="btn btn-icon p-0 btn-active-light-primary w-auto h-auto"
          (click)="onRemoveItem(item.id)"
        >
          <ui-keenicon
            name="cross"
            class="fs-3 text-primary bg-red-400"
          ></ui-keenicon>
        </button>
      </div>
    }
  </div>
}
